export function addCitrusBanner({ state, action }) {
  return {
    ...state,
    citrusAd: { banners: action.banners },
  };
}

